export const PAGINATION_CONFIG = {
  DEFAULT_PAGE_SIZE: 20,
  SIZE_OPTIONS: [25, 50, 100],
};
